import { useEffect, useRef } from 'react';
import { useSlotScreenGeneratorStore } from '../store/slotScreenGeneratorStore';
import { loadIdeaMessageImages } from '../services/slot-screen-generator';
import { hasProjectRoot } from '../services/FileSystemService';

/**
 * Restores blob URLs for idea canvas messages that were saved to disk.
 * Runs once on mount.
 */
export function useRestoreIdeaCanvasImages() {
  const didRestore = useRef(false);

  useEffect(() => {
    if (didRestore.current || !hasProjectRoot()) return;
    didRestore.current = true;

    const restore = async () => {
      const { ideaCanvas } = useSlotScreenGeneratorStore.getState();

      for (const session of ideaCanvas.sessions) {
        for (const msg of session.messages) {
          if (msg.savedImagePaths.length > 0 && msg.images.length === 0) {
            const blobUrls = await loadIdeaMessageImages(msg.savedImagePaths);
            if (blobUrls.length > 0) {
              useSlotScreenGeneratorStore.getState().restoreIdeaMessageImages(
                session.id, msg.id, blobUrls,
              );
            }
          }
        }
      }
    };

    restore().catch(() => {});
  }, []);
}
